import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { DataView } from './components/DataView';
import s from  './index.module.scss';

const LoansLoanPage = () => (
  <div className={s.page}>
    <DataView />
    <MiniFaqs source={MINIFAQ_SOURCES.loans} />
  </div>
);

export default LoansLoanPage;
